import { PlanProvisionsService } from "@/common/api.service";
import { ResetAttributesService } from "@/common/resetPlanProvisionAttributes.service";
import {
  FETCH_ORIGINAL_PLAN_PROVISION,
  UPDATE_PLAN_PROVISION,
  FETCH_AVAILABLE_SELECT_OPTIONS,
  REPORT_FETCH_STATE
} from "./actions.type";
import {
  FETCH_ORIGINAL_PLAN_END,
  SET_AVAILABLE_SELECT_OPTIONS,
  RESET_ATTRIBUTES
} from "./mutations.type";

const state = {
  originalPlan: {},
  selectOptions: {
    auto_enrollment_plan: [],
    auto_increase_available: [],
    funding_frequency: [],
    employee_contrib_entry_date_type: [],
    auto_increase_date_type: [],
    naics_codes: []
  }
};

const getters = {
  originalPlan(state) {
    return state.originalPlan;
  },
  selectOptions(state) {
    return state.selectOptions;
  }
};

const actions = {
  [FETCH_ORIGINAL_PLAN_PROVISION](context, reportId) {
    return PlanProvisionsService.getOriginal(reportId)
      .then(({ data }) => {
        context.commit(FETCH_ORIGINAL_PLAN_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [UPDATE_PLAN_PROVISION](context, { plan }) {
    return PlanProvisionsService.update(plan)
      .then(() => {
        context.dispatch(REPORT_FETCH_STATE, plan.report_id);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_AVAILABLE_SELECT_OPTIONS](context) {
    return PlanProvisionsService.getAvailableSelectOptions()
      .then(({ data }) => {
        context.commit(SET_AVAILABLE_SELECT_OPTIONS, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_ORIGINAL_PLAN_END](state, originalPlan) {
    state.originalPlan = originalPlan;
  },
  [SET_AVAILABLE_SELECT_OPTIONS](state, selectOptions) {
    state.selectOptions = selectOptions;
  },
  [RESET_ATTRIBUTES](state, attribute) {
    const attributes = ResetAttributesService.attributesToReset(
      attribute,
      state.originalPlan[attribute]
    );
    attributes.forEach(attrToReset => (state.originalPlan[attrToReset] = null));
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
